'use strict';

var _ = require('lodash');
var JQXGridColumnGroupFactory = function JQXGridColumnGroupFactory() {
  var JQXGridColumnGroup = function JQXGridColumnGroup(data) {
    this.id = data.id;
    this.name = data.id;
    this.text = data.title;
    this.align = 'center';
    this.groupHeaderClassName = _.kebabCase(data.title);
    this.deleteUndefinedProperties();
  };
  JQXGridColumnGroup.prototype.deleteUndefinedProperties = function () {
    for (var prop in this) {
      if (this.hasOwnProperty(prop) && this[prop] === undefined) {
        delete this[prop];
      }
    }
  };
  return JQXGridColumnGroup;
};
JQXGridColumnGroupFactory.$inject = [];
module.exports = JQXGridColumnGroupFactory;